import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    //  直接使用本地存储的方式
    token: JSON.parse(sessionStorage.getItem('token')) || '',
    //  直接使用本地存储的方式
    UserName: JSON.parse(sessionStorage.getItem('UserName')) || '',
    UserApiKey: JSON.parse(sessionStorage.getItem('UserApiKey')) || '',
    UserDetails: JSON.parse(sessionStorage.getItem('UserDetails')) || '',
    UserHl: JSON.parse(sessionStorage.getItem('UserHl')) || '',
    UserGrDetails: JSON.parse(sessionStorage.getItem('UserGrDetails')) || '',
    axiosArr: [] // 储存cancel token
  },
  mutations: {
    // 存储token
    setToken(state, data) {
      //  修改数据的时候直接存到本地
      sessionStorage.setItem('token', JSON.stringify(data))
      state.token = data
    },
    setUserName(state, data) {
      //  修改数据的时候直接存到本地
      sessionStorage.setItem('UserName', JSON.stringify(data))
      state.UserName = data
    },
    setUserApiKey(state, data) {
      //  修改数据的时候直接存到本地
      sessionStorage.setItem('UserApiKey', JSON.stringify(data))
      state.UserApiKey = data
    },
    setUserDetails(state, data) {
      //  修改数据的时候直接存到本地
      sessionStorage.setItem('UserDetails', JSON.stringify(data))
      state.UserDetails = data
    },
    setUserHl(state, data) {
      //  修改数据的时候直接存到本地
      sessionStorage.setItem('UserHl', JSON.stringify(data))
      state.UserHl = data
    },
    // setUserGrDetails(state, data) {
    // 	//  修改数据的时候直接存到本地
    // 	sessionStorage.setItem('UserGrDetails', JSON.stringify(data))
    // 	state.UserGrDetails = data
    // },
    deleteUser(state) {
      delete state.UserName
      delete state.UserApiKey
      delete state.UserDetails
      delete state.UserHl
    },

    setAxiosArr(state, cancelAjax) {
      state.axiosArr.push(cancelAjax.cancelToken)
    },
    clearAxiosArr(state) {
      state.axiosArr.forEach(item => {
        item()
      })
      state.axiosArr = []
    },
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js